export default __webpack_public_path__ + "static/media/calculate-vector.e9665c7b.png";